import {
  emptyRecordsState,
  type PurchaseHistoryEntry,
  type RecordsState,
  type TokenTransactionEntry,
} from "./types";

export class RecordsModel {
  private purchaseHistory: PurchaseHistoryEntry[] = [];
  private tokenTransactions: TokenTransactionEntry[] = [];

  recordPurchase(entry: PurchaseHistoryEntry): void {
    this.purchaseHistory = [...this.purchaseHistory, { ...entry }];
  }

  recordTokenChange(entry: TokenTransactionEntry): void {
    this.tokenTransactions = [...this.tokenTransactions, { ...entry }];
  }

  getSnapshot(): RecordsState {
    return {
      purchaseHistory: this.purchaseHistory,
      tokenTransactions: this.tokenTransactions,
    };
  }

  restoreState(state: RecordsState): void {
    this.purchaseHistory = state.purchaseHistory.map((entry) => ({ ...entry }));
    this.tokenTransactions = state.tokenTransactions.map((entry) => ({
      ...entry,
    }));
  }

  exportState(): RecordsState {
    return {
      purchaseHistory: this.purchaseHistory.map((entry) => ({ ...entry })),
      tokenTransactions: this.tokenTransactions.map((entry) => ({ ...entry })),
    };
  }
}

export function createEmptyRecordsState(): RecordsState {
  return {
    purchaseHistory: [...emptyRecordsState.purchaseHistory],
    tokenTransactions: [...emptyRecordsState.tokenTransactions],
  };
}
